import { Fragment, ReactNode } from "react";
import { IError } from "src/itsf/fetch/fetcherUtils";
import { Error } from "./Error";
import { Loader } from "./Loader";

interface ILoaderAndError {
    children: ReactNode;
    error?: IError;
    isHomePage?: boolean;
    isLoading: boolean;
    retryFetch?(): void;
}

export const HandleErrorAndLoading = (props: ILoaderAndError) => {
    const { children, isHomePage, error, isLoading, retryFetch } = props;
    const showLoader = !error && isLoading;

    let element = children;

    if (error) {
        element = <Error error={error} isHomePage={isHomePage} retryFetch={retryFetch} />;
    } else if (showLoader) {
        element = <Loader />;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment>{element}</Fragment>;
};
